/* Footer Custom JS — Mobile Accordion */
(function(){
  function initAccordion(){
    document.querySelectorAll('.footer-custom__nav-col h4').forEach(function(title){
      title.addEventListener('click',function(){
        var col=this.closest('.footer-custom__nav-col');
        var isOpen=col.classList.contains('open');
        // close all
        document.querySelectorAll('.footer-custom__nav-col.open').forEach(function(c){c.classList.remove('open')});
        if(!isOpen) col.classList.add('open');
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAccordion)}
  else{initAccordion()}
})();
